import env from './env';

export default (...args) => {
	// Only log for development environments
	if (!env.isDev() || !('console' in window)) {
		return;
	}

	let method = 'log';
	let a = args;

	// First arg can be another `console` method to call ?
	if (typeof console[args[0]] === 'function') { // eslint-disable-line no-console
		[method] = args;
		a = args.slice(1, args.length);
	}

	window.console[method].apply(null, a);
};
